import { defineMessages } from 'react-intl';

const messages = defineMessages({
  downloadPdf: {
    description: 'printDocumentButtonContainers.downloadPdf',
    defaultMessage: 'Download PDF',
    id: '8lZrQg',
  },
});

export const buildDefaultPrintSetting = (documentPrintSetting, onPrintClick, onDownloadClick) => {
  // not having anything set, preview, and always prompt all behave like the default behavior.
  if (!documentPrintSetting || documentPrintSetting.name === 'preview' || documentPrintSetting.name === 'always prompt') {
    return undefined;
  }

  if (documentPrintSetting.name === 'download' && !documentPrintSetting.id) {
    return {
      messageDescriptor: messages.downloadPdf,
      onClick: onDownloadClick,
    };
  }

  return {
    displayText: documentPrintSetting.name,
    onClick: onPrintClick,
  };
};
